import { render, staticRenderFns } from "./AtomicPower.vue?vue&type=template&id=5f083bc0&scoped=true"
import script from "./AtomicPower.vue?vue&type=script&lang=js"
export * from "./AtomicPower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f083bc0",
  null
  
)

export default component.exports